import { useCallback, useState } from 'react'

import { RequestStatus } from 'core/domain/Request'
import { createDownloadLink, triggerDownload } from 'core/utils/link'

import { downloadRfpLanesTemplateFile } from '../../use-cases/downloadRfpLanesTemplateFile'
import {
  uploadRfpLanesFile,
  type UploadRfpLanesFileParams,
} from '../../use-cases/uploadRfpLanesFile'
import { useRfpContext } from '../contexts/RfpContext'

export function useUploadRates() {
  const [uploadStatus, setUploadStatus] = useState<RequestStatus>(RequestStatus.Initial)
  const {
    state: { uploadLanesFileStatus },
    setUploadLanesFileStatus,
  } = useRfpContext()

  const uploadRates = useCallback(
    async (params: UploadRfpLanesFileParams) => {
      if (uploadLanesFileStatus === RequestStatus.Pending) return

      setUploadLanesFileStatus(RequestStatus.Pending)
      setUploadStatus(RequestStatus.Pending)

      try {
        await uploadRfpLanesFile(params)

        setUploadLanesFileStatus(RequestStatus.Done)
        setUploadStatus(RequestStatus.Done)
      } catch (error) {
        setUploadLanesFileStatus(RequestStatus.Error)
        setUploadStatus(RequestStatus.Error)
        throw error
      }
    },
    [setUploadLanesFileStatus, uploadLanesFileStatus]
  )

  const downloadRatesTemplate = useCallback(
    async ({ rfpId, rfpName }: { rfpId: string; rfpName: string }) => {
      const templateBlob = await downloadRfpLanesTemplateFile(rfpId)
      const link = createDownloadLink(templateBlob, `lane_proposals_for_${rfpName}`, '.csv')
      triggerDownload(link)
    },
    []
  )

  const isUploading = uploadStatus === RequestStatus.Pending

  return {
    isUploading,
    downloadRatesTemplate,
    uploadRates,
  }
}
